import { paymentsClient } from '../axiosInstance';
import { IAddress, ICustomer, ITaxIdInfo } from 'features/billing/customer/customerTypes';

const customersURL = process.env.REACT_APP_PAYMENTS_API + '/customers'

export const fetchCustomerById = async (customerId: string) => {
    return await paymentsClient.get<ICustomer>(customersURL + `/${customerId}`);
}

export const fetchCustomerByOrganozationId = async (organozationId: number) => {
    return await paymentsClient.get<ICustomer>(customersURL + `/organizations/${organozationId}`);
}

export const updateCustomerInfo = async (
    customerId: string,
    address: IAddress | null,
    enableAutomaticTax: boolean | null,
    taxIds: ITaxIdInfo[],
) => {
    return await paymentsClient.patch(`${customersURL}/${customerId}`, {
        address: address,
        enableAutomaticTax: enableAutomaticTax,
        taxIds: taxIds,
    });
};

export const addCustomerPaymentCard = async (
    customerId: string,
    cardToken: string
) => {
    return await paymentsClient.post(`${customersURL}/${customerId}/payment-methods`, cardToken);
};

export const addCardIntent = async (customerId: string) => {
    return await paymentsClient.post<string>(customersURL + `/${customerId}/card-intents`);
}

export const setCustomerDefaultPaymentMethod = async (customerId: string, paymentMethodId: string) => {
    return await paymentsClient.post<string>(customersURL + `/${customerId}/payment-methods/${paymentMethodId}/set-default`);
}